'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { PAGES_FETCH, PAGES_CACHE_CLEAR, PAGES_FETCH_BY_ID, PAGES_SAVE_CACHED_PAGE } from 'simple-menus-core/actions/ActionTypes';
import { combineReducers } from 'redux';
import { REQUEST_STATUS } from '../constants/constants';
const EMPTY_STATE = SeamlessImmutable({});
const EMPTY_PAGES_CACHE = SeamlessImmutable({
  pages: {},
  order: []
});
function cache(state = EMPTY_PAGES_CACHE, action) {
  switch (action.type) {
    case PAGES_FETCH:
      {
        const {
          result
        } = action;
        if (!result) return state;
        return result.results.reduce((acc, object) => {
          return acc.setIn(['pages', object.id], object).set('order', acc.order.concat(object.id));
        }, state);
      }
    case PAGES_CACHE_CLEAR:
      {
        return EMPTY_PAGES_CACHE;
      }
    default:
      {
        return state;
      }
  }
}
function pages(state = EMPTY_STATE, action) {
  switch (action.type) {
    case PAGES_FETCH_BY_ID:
      {
        const {
          result
        } = action;
        if (!result) return state;
        return result.results.reduce((acc, object) => {
          return acc.set(object.id, object);
        }, state);
      }
    case PAGES_SAVE_CACHED_PAGE:
      {
        const {
          page
        } = action;
        if (!page) return state;
        return state.set(page.id, page);
      }
    default:
      {
        return state;
      }
  }
}
function pagesRequestStatus(state = REQUEST_STATUS.UNINITIALIZED, action) {
  switch (action.type) {
    case PAGES_FETCH:
    case PAGES_FETCH_BY_ID:
      {
        const {
          result,
          error
        } = action;
        if (!result) return REQUEST_STATUS.PENDING;
        if (error) return REQUEST_STATUS.FAILED;
        return REQUEST_STATUS.SUCCEEDED;
      }
    default:
      {
        return state;
      }
  }
}
export default combineReducers({
  pages,
  pagesRequestStatus,
  cache
});